// extracted by mini-css-extract-plugin
export default {"skills":"skills_skills__b2DhJ","skill":"skills_skill__Gq81z"};